import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import qs from 'query-string';
import Theme from '../../Theme';
import {useOutlet} from 'reconnect.js';
import * as Ant from 'antd';
import Breadcrumb from '../../Components/Breadcrumb';

const columns = [
  {title: '屆次', key: 'session', dataIndex: 'session'},
  {title: '年度(民國)', key: 'years', dataIndex: 'years'},
  {title: '姓名', key: 'username', dataIndex: 'username'},
];

function AboutPreviousChairman(props) {
  const [about] = useOutlet('about');

  // for rowSpan
  const groups = React.useMemo(() => {
    if (Array.isArray(about?.previous_chairman?.after_restructuring)) {
      const data = about?.previous_chairman?.after_restructuring;
      return data.reduce((sum, x, idx) => {
        if (sum[x.session]) {
          sum[x.session].count++;
        } else {
          sum[x.session] = {first: idx, count: 1};
        }
        return sum;
      }, {});
    }
  }, [about?.previous_chairman?.after_restructuring]);

  return (
    <Wrapper>
      <div className="tda-header">
        <h2>歷屆理事長</h2>
        <Breadcrumb third="歷屆理事長" />
      </div>
      <h3>改制前</h3>
      <section>
        <Ant.Table
          dataSource={about?.previous_chairman?.before_restructuring}
          rowKey={(record) => record.session + record.username}
          columns={columns}
          pagination={false}
        />
      </section>

      <h3>改制後</h3>
      <section>
        <Ant.Table
          dataSource={about?.previous_chairman?.after_restructuring}
          rowKey={(record) => record.session + record.username}
          columns={[
            ...columns.map((col, colIdx) => ({
              ...col,
              // for rowSpan
              onCell:
                colIdx < 2
                  ? (item, idx) => {
                      let group = groups[item?.session] || {};
                      if (group.count > 1) {
                        if (group.first === idx) {
                          return {rowSpan: group.count};
                        } else {
                          return {rowSpan: 0};
                        }
                      }
                      return {};
                    }
                  : false,
            })),
            {
              title: '校別',
              key: 'school',
              dataIndex: 'school',
            },
          ]}
          pagination={false}
        />
      </section>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & > h3 {
    border-left: solid 3px var(--primaryColor);
    color: var(--primaryColor);
    padding-left: 20px;
    margin-bottom: 20px;
    font-size: 20px;
  }

  & > section {
    margin-bottom: 20px;
  }
`;

export default withPageEntry(AboutPreviousChairman);
